<template>
  <div :class="$style.page">
    <BaseContainer>
      <NavigationCardsGrid>
        <NavigationCard
          color="aqua"
          :to="{ name: 'Analytics/CarVolumes' }"
        >
          <template #image>
            <CardCarSvg />
          </template>
          <template #title>
            Cars
          </template>
          <template #lead>
            Explore models, generations, and production details.
          </template>
        </NavigationCard>
        <NavigationCard
          color="barley"
          :to="{ name: 'Analytics/LightingDeviceVolumes' }"
        >
          <template #image>
            <CardHeadlampSvg />
          </template>
          <template #title>
            Lighting Devices
          </template>
          <template #lead>
            Explore lighting device usage by date and vehicle type.
          </template>
        </NavigationCard>
      </NavigationCardsGrid>
    </BaseContainer>
  </div>
</template>

<script>
import BaseContainer from '@/components/base/Container';
import NavigationCardsGrid from '@/components/NavigationCardsGrid';
import NavigationCard from '@/components/NavigationCard';
import CardCarSvg from '@/assets/images/icons/card-car.svg?inline';
import CardHeadlampSvg from '@/assets/images/icons/card-headlamp.svg?inline';

export default {
  components: {
    BaseContainer,
    NavigationCardsGrid,
    NavigationCard,
    CardCarSvg,
    CardHeadlampSvg,
  },
};
</script>

<style lang="scss" module>
.page {
  padding-top: map-get($page-vertical-paddings, 'regular');
  padding-bottom: map-get($page-vertical-paddings, 'regular');
}
</style>
